export const ADD_TO_BASKET_ESI_WARNING_OR_ERROR =
  "ADD_TO_BASKET_ESI:WARNING_OR_ERROR";
export const ADD_TO_BASKET_ESI_SUCCESSFULLY_ADDED =
  "ADD_TO_BASKET_ESI:SUCCESSFULLY_ADDED";
export const ADD_TO_BASKET_ESI_QUANTITY_UPDATED =
  "ADD_TO_BASKET_ESI:QUANTITY_UPDATED";
export const ADD_TO_BASKET_ESI_LENGTH_UPDATED =
  "ADD_TO_BASKET_ESI:QUANTITY_UPDATED";
export const ADD_TO_BASKET_ESI_HIDDEN_OR_VISIBLE =
  "ADD_TO_BASKET_ESI:HIDDEN_OR_VISIBLE";
export const SIZE_SELECTOR_ERROR_NO_SIZE_SELECTED =
  "SIZE_SELECTOR:ERROR_NO_SIZE_SELECTED";
export const WARNING_OR_ERROR_EVENT = "ADD_TO_BASKET_ESI:WARNING_OR_ERROR";
export const NO_VARIANT_CODE = "no-variant";
export const OUT_OF_STOCK_CODE = "OUT_OF_STOCK_ONLINE";
export const CHILD_ITEMS_UPDATED_EVENT =
  "ADD_TO_BASKET_ESI:CHILD_ITEMS_UPDATED";
export const SELECTED_SERVICES_UPDATED =
  "SERVICES_AND_WARRANTIES:SELECTED_SERVICES_UPDATED";

export const DELIVERY_SLOTS_CHECKER_SERVICES_CHANGED =
  "DELIVERY_SLOTS_CHECKER:SERVICES_CHANGED";
export const DELIVERY_CHECKER_CHECK_PRESSED = "DELIVERY_CHECKER_CHECK_PRESSED";
export const DELIVERY_CHECKER_RESULTS_DISPLAYED =
  "DELIVERY_CHECKER_RESULTS_DISPLAYED";

export const SERVICE_QUESTIONNAIRE_ESI_SERVICE_SELECTED =
  "SERVICE_QUESTIONNAIRE_ESI:SERVICE_SELECTED";
export const SERVICE_QUESTIONNAIRE_ESI_COMPLETE =
  "SERVICE_QUESTIONNAIRE_ESI:COMPLETE";
export const VIEW_ALL_REVIEWS = "jl-events.browser.viewAllReviews";

export const OFFERTYPE_REDUCED = "ReducedToClear";
export const OFFERTYPE_PROMOTION = "Promotion";

export const OFFERTYPESUMMARY_REDUCED = "ReducedToClear";
export const OFFERTYPESUMMARY_SELECTED_REDUCED = "SelectedReducedToClear";
export const OFFERTYPESUMMARY_PROMOTION = "Promotion";
export const OFFERTYPESUMMARY_SELECTED_PROMOTION = "SelectedPromotion";
export const SUPPLIER_DIRECT_DMS_ID = "14";
export const RECOMMENDATIONS_PANEL_LOADED =
  "jl-recommendations-panel:productsLoaded";
